<div class="page gray-font-color font-family">
  <div class="header-navigation-back" >
    <div class="back-icon" (click)="backAction()"><mat-icon svgIcon="left-arrow"></mat-icon></div>
    <div  class="header-text">Truck / Trailer Images</div>
  </div>

  @if (!showCrop) {
    <div class="content">
      @if (allVehicleImages.length > 0) {
        <div class="image-grid">
          @for (item of allImageUrls; track item; let i = $index) {
            <div class="thumbnail-wrapper">
              @if (item.mimeType === 'image') {
                <img [src]="item.fileUrl" class="thumbnail" alt="Uploaded Image" />
              }
              @if (item.mimeType === 'video') {
                <video
                  [src]="item.fileUrl"
                  class="thumbnail"
                  muted
                  preload="metadata"
                  #video
                  (mouseenter)="video.play()"
                  (mouseleave)="video.pause(); video.currentTime = 0"
                ></video>
              }
              <div class="thumbnail-actions">
                <button mat-icon-button (click)="onDownloadFileClick(item.docId)" [attr.data-testid]="'downloadBtn-' + i">
                  <mat-icon svgIcon="download"></mat-icon>
                </button>
                <button mat-icon-button (click)="deleteDocument(item.docId)" [attr.data-testid]="'deleteBtn-' + i">
                  <mat-icon svgIcon="delete-outlined"></mat-icon>
                </button>
              </div>
            </div>
          }
        </div>
      }
      @if (allVehicleImages.length === 0) {
        <div class="empty-state">
          <div class="empty-state-icon">
            <mat-icon>image</mat-icon>
          </div>
          <p class="empty-state-text">You have no photos yet</p>
        </div>
      }
      
      <!-- Add Pictures Button - Always show when not at max limit -->
      <form [formGroup]="form">
        @if (allVehicleImages?.length < 10) {
          <div class="btn-container">
            <button mat-button class="upload-button" (click)="openActionSheet(pictureSingle, uploadMultiple)" data-testid="uploadBtn">
              <mat-icon>image</mat-icon>
              Add Pictures
            </button>
            <div class="sub-title">
              <span class="max-files">Max 10 files</span>
            </div>
            <div class="inputs-container">
              <input
                #uploadMultiple
                type="file"
                [accept]="acceptTypesMultiple"
                (change)="onUploadFileChange($event)"
                data-test="add-file"
                />
              <input
                #pictureSingle
                type="file"
                name="image"
                [accept]="acceptTypesPicture"
                capture="environment"
                (change)="onProcessPictureFile($event)"
                data-test="add-file"
                />
            </div>
            @if (uploadError) {
              <mat-error>
                {{ uploadError }}
              </mat-error>
            }
          </div>
        }
      </form>
    </div>
  }

  @if (showCrop && environment?.featureFlags?.enableDQFDocImageCropFeature) {
    <div class="content">
      <div [ngClass]="{ 'image-cropper-container': !loading, 'no-height': loading }">
        <image-cropper
          #previewImage
          [imageChangedEvent]="imageChangedEvent"
          [maintainAspectRatio]="false"
          [imageQuality]="100"
          [aspectRatio]="4 / 4"
          [roundCropper]="false"
          [canvasRotation]="canvasRotation"
          [transform]="transform"
          format="png"
          (imageCropped)="onImageCropped($event)"
          (imageLoaded)="onImageLoaded()"
          (cropperReady)="onCropperReady()"
          (loadImageFailed)="onLoadImageFailed()"
          >
        </image-cropper>
      </div>
      @if (loading) {
        <div class="spinner-container">
          <mat-spinner></mat-spinner>
        </div>
      }
      @if (!loading) {
        <div class="save-button-container full-width padding-top-x1">
          <div class="margin-bottom-xlg">
            <div class="button-row-icons">
              <button mat-raised-button class="rotate-icons" (click)="rotateLeft()" data-testid="rotate-left">
                <mat-icon>rotate_left</mat-icon>
              </button>
              <button mat-raised-button class="rotate-icons" (click)="rotateRight()" data-testid="rotate-right">
                <mat-icon>rotate_right</mat-icon>
              </button>
            </div>
            <div class="button-row">
              <button
                class="margin-bottom secondary-button"
                mat-raised-button
                (click)="onCancelCrop()"
                data-test="finish-button"
                data-testid="cancel-button"
                >
                Cancel
              </button>
              <button
                class="margin-bottom primary-button finish-crop-button"
                mat-raised-button
                (click)="onFinishCrop()"
                data-test="finish-button"
                data-testid="finish-button"
                >
                Finish
              </button>
            </div>
          </div>
        </div>
      }
    </div>
  }
</div>
